import type { RealtimeEvent } from './helpers';

import { getMinutes, parseISO } from 'date-fns';
import { VictoryAxis, VictoryBar, VictoryChart } from 'victory';

import { Box } from '../../../components';
import { Dimen } from '../../../constants';
import useDimens from '../useDimens';
import { chartTheme } from './helpers';

type Props = Readonly<{
  allEvents: RealtimeEvent[];
}>;

export default function BoxChartMinutes({ allEvents }: Props) {
  const { measuredEl, width } = useDimens();

  const currentMinute = getMinutes(new Date());
  const dataValues = Array(30).fill(0);
  for (const event of allEvents) {
    let diff = currentMinute - getMinutes(parseISO(event.timestamp));
    if (diff < 0) diff += 60;

    const index = 29 - diff;
    if (index < 0) continue;
    dataValues[index] += 1;
  }

  const max = Math.max(...dataValues);
  const mappedData = dataValues.map((v, i) => ({ x: i, y: v }));

  return (
    <Box title="Events Per Minute">
      <div ref={measuredEl}>
        <VictoryChart
          width={width}
          padding={Dimen.legacySpacing}
          height={200}
          domain={{ y: [0, Math.max(4, max)] }}
          domainPadding={{ x: 10, y: [40, 0] }}
          theme={chartTheme}
        >
          <VictoryAxis tickFormat={(x) => `-${30 - x} min`} tickCount={5} />
          <VictoryAxis
            dependentAxis
            style={{ grid: { stroke: '#eee' } }}
            tickFormat={(y) => Math.round(parseFloat(y))}
          />
          <VictoryBar data={mappedData} cornerRadius={2} barWidth={6} />
        </VictoryChart>
      </div>
    </Box>
  );
}
